import { render, staticRenderFns } from "./CopTestParameterList.vue?vue&type=template&id=b31082f4&scoped=true&"
import script from "./CopTestParameterList.vue?vue&type=script&lang=js&"
export * from "./CopTestParameterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31082f4",
  null
  
)

export default component.exports